import * as z from 'zod';

import { recruitingQuerySchema } from './recruiting-query-schema';

export const recruitingMutationSchema = recruitingQuerySchema
  .omit({
    profile_image: true,
    resume: true,
    additional_documents: true,
    recruiting_job_categories: true,
    hiring_criteria_categories: true,
    phone_numbers: true,
  })
  .extend({
    profile_image: z.array(z.number()),
    resume: z.array(z.number()),
    additional_documents: z.array(z.number()),
    recruiting_job_categories: z.array(z.number()),
    hiring_criteria_categories: z.array(z.number()),
    phone_numbers: z.array(z.number()),
  });

export type RecruitingMutationSchema = z.infer<typeof recruitingMutationSchema>;

export const recruitingCreateSchema = recruitingMutationSchema.omit({
  id: true,
});

export type RecruitingCreateSchema = z.infer<typeof recruitingCreateSchema>;
